import type { FC } from "react";

import styles from "./SelectedAddressView.module.scss";

export type SelectedAddress = {
  street?: string;
  city?: string;
  postCode?: string;
  country?: string;
};

type SelectedAddressViewProps = {
  title?: string;
  address: SelectedAddress;
  children?: React.ReactNode;
};

export const SelectedAddressView: FC<SelectedAddressViewProps> = ({ title, address, children }) => (
  <div className={styles.container}>
    {!!title && <p className={styles.title}>{title}</p>}

    <div>
      {!!address.street && <p className={styles.bodyText}>{address.street}</p>}

      {!!address.city && (
        <p className={styles.bodyText}>
          {address.postCode} {address.city}
        </p>
      )}

      {!!address.country && <p className={styles.bodyText}>{address.country}</p>}
    </div>

    {children}
  </div>
);
